"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = void 0;
const yup_1 = require("yup");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
// TODO add more validation
exports.validationSchema = (0, yup_1.object)().shape({
    deposit: mui_inputs_asset_1.templateAssetValidationSchema,
    reward: mui_inputs_asset_1.templateAssetValidationSchema,
    contractId: yup_rules_1.dbIdValidationSchema,
});
//# sourceMappingURL=validation.js.map